import { VehicleModel } from '@/lib/models/vehicle/types';

export const getVehicleName = (vehicle: VehicleModel): string => {
  if (vehicle?.names?.short?.length) {
    const name: string = vehicle.names.short[0];
    return name.split(' Passenger')[0];
  }
  return '';
};
